import { Link } from "react-router-dom";
import { useSettings } from "@/context/SettingsContext";
import { ContactFooterBlock } from "@/components/ContactItems";

export function Footer() {
  const { settings } = useSettings();
  return (
    <footer className="mt-20 border-t border-slate-800 bg-slate-900 text-slate-300">
      <div className="mx-auto grid max-w-7xl gap-10 px-4 py-14 sm:px-6 md:grid-cols-2 lg:grid-cols-4 lg:px-8">
        <div className="lg:col-span-1">
          <span className="font-display text-2xl font-extrabold text-white">
            MASHIN<span className="text-orange">IYA</span>
          </span>
          <p className="mt-1 text-xs font-medium uppercase tracking-widest text-slate-500">
            {settings.tagline}
          </p>
          <p className="mt-1 text-xs text-slate-400">Mashiniya by {settings.parent_company}</p>
          <p className="mt-4 max-w-xs text-sm leading-relaxed text-slate-400">{settings.footer_text}</p>
        </div>

        <div>
          <h4 className="mb-4 font-display text-sm font-bold uppercase tracking-wider text-white">Explore</h4>
          <ul className="space-y-2.5 text-sm">
            <li><Link to="/" className="hover:text-[hsl(var(--brand))]">Home</Link></li>
            <li><Link to="/new-machines" className="hover:text-[hsl(var(--brand))]">New Machines</Link></li>
            <li><Link to="/used-machines" className="hover:text-[hsl(var(--brand))]">Used Machines</Link></li>
            <li><Link to="/spare-parts" className="hover:text-[hsl(var(--brand))]">Spare Parts</Link></li>
            <li><Link to="/categories" className="hover:text-[hsl(var(--brand))]">Categories</Link></li>
            <li><Link to="/about" className="hover:text-[hsl(var(--brand))]">About Us</Link></li>
            <li><Link to="/contact" className="hover:text-[hsl(var(--brand))]">Contact</Link></li>
            <li><Link to="/sell-your-machine" className="hover:text-[hsl(var(--brand))]">List Your Product</Link></li>
          </ul>
        </div>

        <div>
          <h4 className="mb-4 font-display text-sm font-bold uppercase tracking-wider text-white">Legal</h4>
          <ul className="space-y-2.5 text-sm">
            <li><Link to="/privacy-policy" className="hover:text-[hsl(var(--brand))]">Privacy Policy</Link></li>
            <li><Link to="/terms" className="hover:text-[hsl(var(--brand))]">Terms &amp; Conditions</Link></li>
          </ul>
        </div>

        <div>
          <h4 className="mb-4 font-display text-sm font-bold uppercase tracking-wider text-white">Contact</h4>
          <p className="mb-3 text-sm font-semibold text-white">{settings.parent_company}</p>
          <ContactFooterBlock />
        </div>
      </div>

      <div className="border-t border-slate-800 px-4 py-6">
        <p className="mx-auto max-w-7xl text-xs leading-relaxed text-slate-500">
          Mashiniya is a platform that helps buyers and sellers discover and connect with each other. Buyers should independently
          verify machine or spare part condition, ownership, documents, specifications, compatibility, price, payment terms and other
          transaction details directly with the seller before completing any transaction.
        </p>
        <p className="mx-auto mt-4 max-w-7xl text-xs text-slate-500">
          © 2026 Mashiniya. A product of {settings.parent_company}. All rights reserved.
        </p>
      </div>
    </footer>
  );
}
